module.exports = __webpack_public_path__ + "img/header-img-v6.60f2e822.jpg";